import { createFileRoute } from "@tanstack/react-router";
import { PhoneOutgoing } from "lucide-react";
import { AdminEmptyTab } from "@/components/dashboard/AdminEmptyTab";

export const Route = createFileRoute("/dashboard/admin/call")({
  head: () => ({ meta: [{ title: "Calls · Admin" }, { name: "robots", content: "noindex" }] }),
  component: () => (
    <AdminEmptyTab
      title="Calls"
      description="Outbound and inbound voice activity across the platform."
      stats={[
        { label: "Calls (24h)" },
        { label: "Inbound" },
        { label: "Outbound" },
        { label: "Avg. duration" },
      ]}
      body="Call logs and voice activity will appear here."
      primaryAction={{ label: "Place call", icon: PhoneOutgoing }}
      columns={["Direction", "Number", "Duration", "Outcome", "Started", "Cost"]}
    />
  ),
});
